import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';


import StudentAttendance from './StudentAttendance';
import StudentMarks from './StudentMarks';
import StudentAnnouncements from './StudentAnnouncements';
import StudentAssignments from './StudentAssignments';
import StudentQuizzes from './StudentQuizzes';
import StudentFees from './StudentFees';
import StudentComplaints from './StudentComplaints';
import StudentTimetable from './StudentTimetable';
import StudentNotices from './StudentNotices';
import WeeklyReport from './WeeklyReport';
import StudentTeacherRating from './StudentTeacherRating';
const BASE_URL = process.env.REACT_APP_API_URL?.replace('/api','') || 'http://localhost:5000';


const Dashboard = () => {
  const { user, logoutUser } = useAuth();
  const navigate = useNavigate();
  const [activeMenu, setActiveMenu] = useState('dashboard');
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '🏠' },
    { id: 'attendance', label: 'My Attendance', icon: '✅' },
    { id: 'marks', label: 'My Marks', icon: '📊' },
    { id: 'announcements', label: 'Announcements', icon: '📢' },
    { id: 'assignments', label: 'Assignments', icon: '📝' },
    { id: 'quizzes', label: 'Quizzes', icon: '❓' },
    { id: 'fees', label: 'My Fees', icon: '💰' },
    { id: 'timetable', label: 'Timetable', icon: '📅' },
    { id: 'notices', label: 'Notice Board', icon: '📌' },
    { id: 'complaints', label: 'Complaints', icon: '💬' },
    { id: 'teacher-ratings', label: 'Teacher Ratings', icon: '⭐' },
    { id: 'report', label: 'My Report', icon: '📈' },
  ];

  const handleMenu = (id) => {
    setActiveMenu(id);
    navigate(`/student/${id}`);
    setSidebarOpen(false);
  };

  const handleLogout = () => {
    logoutUser();
    navigate('/login');
  };

  const isMobile = window.innerWidth <= 768;

  return (
    <div style={styles.container}>
      {/* Mobile Overlay */}
      {sidebarOpen && isMobile && (
        <div onClick={() => setSidebarOpen(false)} style={styles.overlay} />
      )}

      {/* Sidebar */}
      <div style={{
        ...styles.sidebar,
        left: isMobile ? (sidebarOpen ? '0' : '-260px') : '0',
        transition: 'left 0.3s ease',
        zIndex: 1000,
      }}>
        <div style={styles.sidebarHeader}>
          <img src="/logo.png" alt="logo" style={styles.logo} />
          <h3 style={styles.collegeName}>Stars College</h3>
          <p style={styles.campusName}>Tibbi Qaisrani Campus</p>
        </div>
        <div style={styles.userInfo}>
          <div style={styles.avatar}>
            {user?.profile_pic
              ? <img src={`${BASE_URL}/uploads/${user.profile_pic}`}
                  alt="" style={styles.avatarImg} />
              : user?.name?.charAt(0).toUpperCase()
            }
          </div>
          <div>
            <p style={styles.userName}>{user?.name}</p>
            <p style={styles.userRole}>Student</p>
          </div>
        </div>
        <nav style={styles.nav}>
          {menuItems.map(item => (
            <button key={item.id}
              style={{ ...styles.navItem, ...(activeMenu === item.id ? styles.navItemActive : {}) }}
              onClick={() => handleMenu(item.id)}>
              <span>{item.icon}</span> {item.label}
            </button>
          ))}
        </nav>
        <button onClick={handleLogout} style={styles.logoutBtn}>
          🚪 Logout
        </button>
      </div>

      {/* Main Content */}
      <div style={{
        ...styles.mainContent,
        marginLeft: isMobile ? '0' : '250px',
      }}>
        <div style={styles.topBar}>
          {isMobile && (
            <button onClick={() => setSidebarOpen(!sidebarOpen)} style={styles.hamburger}>
              ☰
            </button>
          )}
          <h2 style={styles.pageTitle}>Student Portal</h2>
          <p style={styles.welcome}>Welcome, {user?.name}!</p>
        </div>
        <div style={styles.content}>
          <Routes>
            <Route path="/" element={<StudentHome user={user} />} />
            <Route path="/dashboard" element={<StudentHome user={user} />} />
            <Route path="/attendance" element={<StudentAttendance />} />
            <Route path="/marks" element={<StudentMarks />} />
            <Route path="/announcements" element={<StudentAnnouncements />} />
            <Route path="/assignments" element={<StudentAssignments />} />
            <Route path="/quizzes" element={<StudentQuizzes />} />
            <Route path="/fees" element={<StudentFees />} />
            <Route path="/timetable" element={<StudentTimetable />} />
            <Route path="/notices" element={<StudentNotices />} />
            <Route path="/complaints" element={<StudentComplaints />} />
            <Route path="/teacher-ratings" element={<StudentTeacherRating />} />
            <Route path="/report" element={<WeeklyReport />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};

const StudentHome = ({ user }) => (
  <div>
    <h3 style={{ color: '#1a3a5c', marginBottom: '20px' }}>
      Welcome, {user?.name}!
    </h3>
    <div style={styles.statsGrid}>
      {[
        { icon: '✅', label: 'View Attendance' },
        { icon: '📊', label: 'View Marks' },
        { icon: '📢', label: 'Announcements' },
        { icon: '❓', label: 'Take Quizzes' },
        { icon: '💰', label: 'Fee Status' },
        { icon: '📅', label: 'Timetable' },
        { icon: '📌', label: 'Notice Board' },
        { icon: '💬', label: 'Complaints' },
      ].map((item, i) => (
        <div key={i} style={styles.statCard}>
          <h2 style={styles.statIcon}>{item.icon}</h2>
          <p style={styles.statLabel}>{item.label}</p>
        </div>
      ))}
    </div>
  </div>
);

const styles = {
  container: { display: 'flex', minHeight: '100vh', fontFamily: 'Arial, sans-serif' },
  overlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', zIndex: 999 },
  sidebar: {
    width: '250px',
    background: 'linear-gradient(180deg, #1a3a5c 0%, #0d2a4a 100%)',
    display: 'flex',
    flexDirection: 'column',
    position: 'fixed',
    height: '100vh',
    overflowY: 'auto',
  },
  sidebarHeader: { textAlign: 'center', padding: '20px 15px', borderBottom: '1px solid rgba(255,255,255,0.1)' },
  logo: { width: '60px', height: '60px', borderRadius: '50%' },
  collegeName: { color: 'white', fontSize: '16px', margin: '8px 0 2px' },
  campusName: { color: 'rgba(255,255,255,0.6)', fontSize: '11px', margin: 0 },
  userInfo: { display: 'flex', alignItems: 'center', gap: '10px', padding: '15px', borderBottom: '1px solid rgba(255,255,255,0.1)' },
  avatar: { width: '36px', height: '36px', borderRadius: '50%', background: '#0d6efd', color: 'white', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 'bold', fontSize: '16px', overflow: 'hidden' },
  avatarImg: { width: '100%', height: '100%', objectFit: 'cover' },
  userName: { color: 'white', margin: 0, fontSize: '13px', fontWeight: 'bold' },
  userRole: { color: 'rgba(255,255,255,0.6)', margin: 0, fontSize: '11px' },
  nav: { flex: 1, padding: '10px 0' },
  navItem: { width: '100%', padding: '11px 20px', background: 'transparent', border: 'none', color: 'rgba(255,255,255,0.8)', textAlign: 'left', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '10px' },
  navItemActive: { background: 'rgba(13,110,253,0.4)', color: 'white', borderLeft: '3px solid #0d6efd' },
  logoutBtn: { margin: '10px 15px 20px', padding: '10px', background: 'rgba(220,53,69,0.3)', border: '1px solid rgba(220,53,69,0.5)', color: 'white', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  mainContent: { flex: 1, background: '#f5f7fa', minHeight: '100vh' },
  topBar: { background: 'white', padding: '15px 25px', borderBottom: '1px solid #e0e0e0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  hamburger: { background: 'none', border: 'none', fontSize: '24px', cursor: 'pointer', color: '#1a3a5c', marginRight: '10px' },
  pageTitle: { margin: 0, color: '#1a3a5c', fontSize: '20px' },
  welcome: { margin: 0, color: '#666', fontSize: '14px' },
  content: { padding: '25px' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '15px' },
  statCard: { background: 'white', borderRadius: '12px', padding: '20px', textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.08)' },
  statIcon: { fontSize: '35px', margin: '0 0 8px' },
  statLabel: { color: '#666', fontSize: '13px', margin: 0 },
};

export default Dashboard;